module.exports = __webpack_public_path__ + "img/e81b5eebfe85490ca4813c7f38186c22.b704cb3c.png";